/* TODO: avoid hardcoding NT_BASIC_PRODUCT_KEY
 *  delete all NT_BASIC_PRODUCT_KEY usages and get that info from the backend
 */
const NT_BASIC_PRODUCT_KEY = "MarketingNoTouchBasic";
export const NT_SEARCH_MARKETING_PRODUCT_KEY = "GrowSearchNoTouch";
export const NT_DISPLAY_MARKETING_PRODUCT_KEY = "GrowDisplayNoTouch";
export const NT_AFFILIATE_MARKETING_PRODUCT_KEY = "GrowAffiliateNoTouch";
export const NT_ADVANCED_PRODUCT_KEY = "AdvancedNoTouch";
export const NT_ESSENTIAL_PRODUCT_KEY = "EssentialNoTouch";
